import { gql, useMutation } from '@apollo/client';

import type {
  UpdateRemittanceVarianceStatus,
  UpdateRemittanceVarianceStatusVariables,
} from './__generated__/updateRemittanceVarianceStatus_gql';
export const UPDATE_REMITTANCE_VARIANCE_STATUS = gql`
  mutation UpdateRemittanceVarianceStatus($input: UpdateRemittanceVarianceStatusInput!) {
    updateRemittanceVarianceStatus(input: $input) {
      item {
        upload_id
        account_id
        payment_month
        variance_code
        status
        note
        version
        updated_at_milliseconds
      }
    }
  }
`;

/**
 * Update a remittance variance's acknowledge status and/or note. The backend supports
 * note-only saves (same status, new note) — callers preserve the current status when
 * they only want to persist note changes. Status transitions (PENDING → ACKNOWLEDGED)
 * can be combined with a note in a single call.
 *
 * Optimistic-lock: callers pass `expected_version` from the variance item they're
 * editing. A mismatch surfaces as an Apollo error; callers should refetch and reconcile.
 */
export function useUpdateRemittanceVarianceStatus() {
  return useMutation<UpdateRemittanceVarianceStatus, UpdateRemittanceVarianceStatusVariables>(
    UPDATE_REMITTANCE_VARIANCE_STATUS,
  );
}
